import { Skeleton } from '@mui/material';
import { calculateLocatinVars } from '../../../libs/browser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonDescription from '../../../components/CommonDescription';
import Context from '../../../provider';
import ErrorPage from '../../../pages/ErrorPage';
import IconAboutHKDC from '../../../assets/hkdc/icons/AboutHKDCIcon';
import LogoFooterComponent from '../../../components/LogoFooterComponent';
import PageTitleContComponent from '../../../components/PageTitleContComponent';
import React, { useContext, useEffect, useRef, useState } from 'react';
import memberApi from '../../../libs/api/memberApi';
import useIsScrolling from '../../../hooks/useIsScrolling';
import useNotificationsCount from '../../../hooks/useNotificationsCount';

import './index.scss';

export default function WebFellowPage() {
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);
  const { init, dispatch, lang, me } = useContext(Context);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const notificationNotReadCount = useNotificationsCount();

  const scrollRef = useRef(null);
  const isScrolling = useIsScrolling(scrollRef.current);

  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [pageNotFound, setPageNotFound] = useState(false);

  const fetchData = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const page = await memberApi.getPage({ ruri: locationVars.join('/') });
      setData(page);
      setLoaded(true);
    } catch (error) {
      setPageNotFound(true);
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (init) fetchData();
  }, [init]);

  // This page only allow logged in user
  useEffect(() => {
    // if (init) {
    //   if (!me) navigate(`${config.basename}login?redirect=${locationVars.join('/')}`);
    //   if (me?.status === 'new') navigate(`${config.basename}signup?redirect=${locationVars.join('/')}`);
    // }
  }, [init, me]);

  const getSectionStyle = (section) => {
    const style = {};
    if (section?.color_background_class) style.backgroundColor = section.color_background_class;
    if (section?.color_foreground_class) style.color = section.color_foreground_class;
    if (section?.background_texture) style.backgroundImage = `url(${section.background_texture})`;
    return style;
  };

  return (
    <>
      {pageNotFound && <ErrorPage type="notFound" />}
      {!pageNotFound && (
        <div className='web-fellow-page'>

          <div ref={scrollRef} className='y-overflow gray-block content-container'>
            <div className="black-block full-width">
              <PageTitleContComponent
                titleText={data?.title?.[lang]}
                descText={<CommonDescription data={data?.meta_description?.[lang] ?? ''} />}
                titleContStyle={{
                  gap: '0.5rem'
                }}
                pageTitleIcon={
                  <IconAboutHKDC
                  style={{
                    width: '25.575rem',
                    height: '18.5625rem'
                  }}
                  size="large" />
                }
              />
            </div>

            <div className="section-max-container section">
              {data?.sections && data.sections.length > 0 && data.sections[0].image[lang] && <div className='img-cont' style={{ backgroundImage: `url(${data.sections[0].image?.[lang]})` }} />}
              <div className='app-container white-block'>
                {loaded && (data?.sections ??[]).map((section, index) => {
                  return (
                    <section className={ section.color_background_class ?? 'common-section' } key={`${section.anchor}-${index}`} style={getSectionStyle(section)}>
                      <div className="section-content-cont"
                        style={{
                          flexDirection: section.container_behavior && section.container_behavior === 'container-direction-rtl' ? 'row-reverse' : 'row'
                        }}
                      >
                        {
                          section.image[lang] &&
                          <img
                            className='img-cont'
                            alt='section img'
                            src={ section.image[lang] }
                            style={{
                              width: section.container_behavior && section.container_behavior === 'container-direction-rtl' ? '40%' : '60%',
                              height: section.container_behavior && section.container_behavior === 'container-direction-rtl' ? 'max-content' : 'max-content'
                            }}
                          />
                        }
                        <CommonDescription
                          title={section.hide_title ? null : section?.title?.[lang]}
                          data={section?.content?.[lang]}
                        />
                      </div>
                    </section>
                  );
                })}
                {!loaded && (
                  <>
                    <Skeleton animation="wave" variant="rounded" height={16} width='80%' className='skeleton' />
                    <Skeleton animation="wave" variant="rounded" height={16} width='100%' className='skeleton' />
                    <Skeleton animation="wave" variant="rounded" height={16} width='50%' className='skeleton' />
                  </>
                )}
              </div>
            </div>
            <div className="black-block full-width">
              <LogoFooterComponent />
            </div>
          </div>
        </div>
      )}
    </>
  );
}